import { combineReducers } from "redux";
// import welcomes from "../features/admin/aboutus/welcomes/Slice";
import review_rating from "../features/admin/ReviewRating/review_rating/Slice";



const customers = combineReducers({
    review_rating: review_rating,
   
  });
  
  export default customers;